import React from 'react';

function EffectiveFans() {
  return (
    <iframe
      src="/yfx/"
      title="有效粉丝查询"
      style={{
        width: '100%',
        height: 'calc(100vh - 160px)',
        border: 'none',
        borderRadius: 8,
      }}
    />
  );
}

export default EffectiveFans;